$(function() {
    if (window.location.pathname == '/' || window.location.pathname == '/apartments') {
        $('#header-search').on('click', function() {
            $('.search-window').addClass('search-window_show');
            $('.header__search').addClass('header__search_hidden');
        });

        $('.search-window__close').on('click', function() {
            $('.search-window').removeClass('search-window_show');
            $('.header__search').removeClass('header__search_hidden');
        });
    } else {
        $('#header-search').remove();
    }
})
